<article class="content-card column-quarter course">
    <div class="caption-div">
        <a href="javascript:void(0)" class="link" (click)="goToSearchResults()">{{jobOrganizationsLast?.name}}</a>
    </div>
</article>